var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#cacedd;}.cls-1{opacity:0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 41,
    height: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.5.5C12.81.5,5.83,4.71.68,11.54a1.61,1.61,0,0,0,0,1.91C5.83,20.29,12.81,24.5,20.5,24.5s14.67-4.21,19.82-11a1.61,1.61,0,0,0,0-1.91C35.17,4.71,28.19.5,20.5.5ZM21.05,21a8.47,8.47,0,1,1,7.9-7.9A8.48,8.48,0,0,1,21.05,21Zm-.25-3.9a4.56,4.56,0,1,1,4.25-4.26A4.57,4.57,0,0,1,20.8,17.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.f4271a59115a9f60b024c6c64dd28a22.svg";
export { ForwardRef as ReactComponent };